export default {
  instance: {
    endpoint: 'https://dev.auris.cloud/rs/v2/instance'
  },
  selfSupport: {
    endpoint: 'https://dev.auris.cloud/api/rs/v3/self-support'
  },
  servicedesksupport: {
    endpoint: 'https://dev.auris.cloud/api/rs/v3/service-desk-support'
  },
  session: {
    endpoint: 'https://dev.auris.cloud/api/rs/v3/session'
  },
  recaptcha: {
    sitekey: '6Lc1jycjAAAAAJP8D0AG6nXrZKE-I7sDH7gfmJWp'
  },
  apiKey: '971905f0-b728-42dc-bcb0-403a41b02c54',
  sessionToken: ''
}
